"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const Contract = __importStar(require("@tableau/api-external-contract-js"));
const api_shared_js_1 = require("@tableau/api-shared-js");
class PulseFilter {
    constructor(_fieldName, _filterType, _metricId, _registryId) {
        this._fieldName = _fieldName;
        this._filterType = _filterType;
        this._metricId = _metricId;
        this._registryId = _registryId;
    }
    get fieldName() {
        return this._fieldName;
    }
    get filterType() {
        return this._filterType;
    }
    get metricId() {
        return this._metricId;
    }
}
exports.PulseFilter = PulseFilter;
class CategoricalPulseFilter extends PulseFilter {
    constructor(fieldName, metricId, filterType, registryId, _appliedValues, _isExcludeMode, _isAllSelected) {
        super(fieldName, filterType, metricId, registryId);
        this._appliedValues = _appliedValues;
        this._isExcludeMode = _isExcludeMode;
        this._isAllSelected = _isAllSelected;
    }
    get isAllSelected() {
        return this._isAllSelected;
    }
    get appliedValues() {
        return this._appliedValues;
    }
    get isExcludeMode() {
        return this._isExcludeMode;
    }
    getDomainAsync(searchTerm, pageSize, nextPageToken, domainType) {
        if (!domainType) {
            domainType = Contract.FilterDomainType.Relevant;
        }
        api_shared_js_1.ErrorHelpers.verifyEnumValue(domainType, Contract.FilterDomainType, 'Contract.FilterDomainType');
        const service = api_shared_js_1.ApiServiceRegistry.get(this._registryId).getService("PulseService" /* PulseService */);
        return service.getCategoricalDomainAsync(this._fieldName, domainType, searchTerm, pageSize, nextPageToken);
    }
}
exports.CategoricalPulseFilter = CategoricalPulseFilter;
//# sourceMappingURL=PulseFilter.js.map